module.exports = __webpack_public_path__ + "static/media/bianzu6.c8a41d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bianzu6.png
// module id = 2157
// module chunks = 0